<!-- One visual treatment across the whole rail. The weekly and monthly halves used to be
     drawn as different objects (the month cells sat in a rounded grey box) separated only
     by a hairline, with nothing saying what had changed, which read as an accident rather
     than as a change of scale. Now every cell is the same object, the divider is visible,
     and the legend underneath says where weeks stop and months start. -->
<div class="rail" role="list">
  @for (b of data.weekly; track b.weekStart; let i = $index) {
    <button type="button" class="cell"
      [class.hit]="b.comingFree > 0" [disabled]="b.comingFree === 0"
      [title]="b.weekStart" (click)="pick(b)">
      <span class="eur">{{ data.moneyVisible ? kEuro(b.endingRevenueWeekly) : '' }}</span>
      <span class="dot" [class.on]="b.comingFree > 0">{{ b.comingFree > 0 ? b.comingFree : '' }}</span>
      <span class="lbl">{{ i === 0 || i === data.weekly.length - 1 ? weekDay(b.weekStart!) : '' }}</span>
    </button>
  }
  <span class="rail-sep" [attr.aria-label]="'dashboard.team.rail_monthly' | translate"></span>
  @for (b of data.monthly; track b.monthStart) {
    <button type="button" class="cell month"
      [class.hit]="b.comingFree > 0" [disabled]="b.comingFree === 0"
      [title]="b.monthStart" (click)="pick(b)">
      <span class="eur">{{ data.moneyVisible ? kEuro(b.endingRevenueWeekly) : '' }}</span>
      <span class="dot" [class.on]="b.comingFree > 0">{{ b.comingFree > 0 ? b.comingFree : '' }}</span>
      <span class="lbl">{{ b.monthStart | date: 'LLL' }}</span>
    </button>
  }
</div>
<p class="rail-legend">{{ 'dashboard.team.rail_legend' | translate }}</p>
@if (!hasEvents()) {
  <p class="rail-empty">{{ 'dashboard.team.no_rolloff' | translate }}</p>
}
